import React, { ReactElement } from 'react';
import { css } from '@emotion/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faChartBar,
  faCloud,
  faCloudDownloadAlt,
  faCog,
  faCogs,
  faEdit,
  faMagic,
  faSitemap,
  faStar,
  faUser,
  faUsers,
  faTasks,
  faComments,
  faCertificate,
  faChevronDown,
  faChevronRight,
  faHome,
} from '@fortawesome/pro-solid-svg-icons';
import { faClock, faImage, faSmile } from '@fortawesome/pro-regular-svg-icons';

declare type CourseAdminLinkAction =
  | 'starter'
  | 'outcomes'
  | 'general'
  | 'landing_page'
  | 'appearance'
  | 'content'
  | 'groups'
  | 'community'
  | 'roles'
  | 'exports'
  | 'advanced';

declare type CohortAdminLinkAction =
  | 'general'
  | 'timeline'
  | 'students'
  | 'statistics'
  | 'advanced';

declare type CourseAssessmentLinkAction = 'settings' | 'design' | 'assess';

declare type CourseCertificationLinkAction =
  | 'settings'
  | 'appearance'
  | 'certificates';

const CourseAdminLinkIconProp: {
  [key in
    | CourseAdminLinkAction
    | CohortAdminLinkAction
    | CourseAssessmentLinkAction
    | CourseCertificationLinkAction]: IconProp;
} = {
  starter: faMagic,
  outcomes: faStar,
  general: faEdit,
  landing_page: faCloud,
  appearance: faImage,
  content: faSitemap,
  groups: faUsers,
  community: faSmile,
  roles: faUser,
  students: faUser,
  exports: faCloudDownloadAlt,
  advanced: faCogs,
  timeline: faClock,
  statistics: faChartBar,
  settings: faCog,
  design: faTasks,
  assess: faComments,
  certificates: faCertificate,
};

export const CourseAdminLinkIcon = React.memo(
  ({ action }: { action: CourseAdminLinkAction }): ReactElement => {
    return (
      <span className="course-admin-nav-icon">
        <FontAwesomeIcon
          icon={CourseAdminLinkIconProp[action]}
          fixedWidth
          css={css({ fontSize: '12px' })}
        />
      </span>
    );
  }
);

export const CourseAdminNavToggleIcon = React.memo(
  ({ expanded }: { expanded: boolean }): ReactElement => (
    <FontAwesomeIcon
      icon={expanded ? faChevronDown : faChevronRight}
      fixedWidth
    />
  )
);

declare type CoursePageLinkIconName = 'home' | null;

export const CoursePageLinkIcon = React.memo(
  ({ icon }: { icon: CoursePageLinkIconName }): ReactElement | null =>
    icon === 'home' ? (
      <>
        <FontAwesomeIcon icon={faHome} fixedWidth />{' '}
      </>
    ) : null
);
